import React from "react";
import { useNavigate } from "react-router-dom";
import CountdownTimer from "../common/Timer";

const SurpriseScreen = () => {
  const navigate = useNavigate();
  return (
    <section id="screen-surprise" className="screen">
      {/* Background */}
      <div className="surprise-background">
        <div className="star" style={{ "--x": "10%", "--delay": "0s" }}>
          ⭐
        </div>
        <div className="star" style={{ "--x": "30%", "--delay": "0.3s" }}>
          ✨
        </div>
        <div className="star" style={{ "--x": "50%", "--delay": "0.6s" }}>
          ⭐
        </div>
        <div className="star" style={{ "--x": "70%", "--delay": "0.9s" }}>
          ✨
        </div>
        <div className="star" style={{ "--x": "90%", "--delay": "1.2s" }}>
          ⭐
        </div>
      </div>

      <div className="surprise-content">
        <h1 className="surprise-title">A Special Song For You 🎵</h1>
        <p className="surprise-subtitle">
          Scan the code to hear my heart&apos;s melody
        </p>

        <div className="surprise-display">
          {/* Vinyl */}
          <div className="vinyl-container">
            <div className="vinyl-record">
              <div className="vinyl-grooves" />
              <div className="vinyl-label">
                <span className="vinyl-heart">❤️</span>
                <span className="vinyl-text">Our Song</span>
              </div>
            </div>
            <div className="tonearm" />
          </div>

          {/* QR Section */}
          <div className="qr-section">
            <div className="qr-arrows left">
              <svg viewBox="0 0 50 30">
                <defs>
                  <marker
                    id="arrowL"
                    markerWidth="10"
                    markerHeight="7"
                    refX="9"
                    refY="3.5"
                    orient="auto"
                  >
                    <polygon points="0 0, 10 3.5, 0 7" fill="#FF1493" />
                  </marker>
                </defs>
                <path
                  d="M45 15Q25 5 10 15"
                  stroke="#FF1493"
                  strokeWidth="2"
                  fill="none"
                  markerEnd="url(#arrowL)"
                />
              </svg>
            </div>

            <div className="qr-code-wrapper">
              <div className="qr-frame">
                <div className="corner corner-tl" />
                <div className="corner corner-tr" />
                <div className="corner corner-bl" />
                <div className="corner corner-br" />

                <iframe
                  key={"song-dedication"}
                  title="song-dedication"
                  data-testid="embed-iframe"
                  style={{ "border-radius": "10px" }}
                  src="https://open.spotify.com/embed/track/2LYeOtjaSZhBvMEyvVjxYT?utm_source=generator&theme=0"
                  width="100%"
                  height="152"
                  frameBorder=""
                  allowfullscreen="true"
                  allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                  loading="lazy"
                ></iframe>
              </div>
            </div>

            <div className="qr-arrows right">
              <svg viewBox="0 0 50 30">
                <defs>
                  <marker
                    id="arrowR"
                    markerWidth="10"
                    markerHeight="7"
                    refX="9"
                    refY="3.5"
                    orient="auto"
                  >
                    <polygon points="0 0, 10 3.5, 0 7" fill="#FF1493" />
                  </marker>
                </defs>
                <path
                  d="M5 15Q25 5 40 15"
                  stroke="#FF1493"
                  strokeWidth="2"
                  fill="none"
                  markerEnd="url(#arrowR)"
                />
              </svg>
            </div>
          </div>
        </div>

        {/* Final Message */}
        <div className="final-message">
          <p>
            &quot;Every love story is beautiful, but ours is my favorite&quot;
          </p>
          <div className="final-hearts">
            <span>💕</span>
            <span>💖</span>
            <span>💝</span>
            <span>💗</span>
            <span>💘</span>
          </div>
        </div>

        {/* Restart */}
        {new Date().toLocaleDateString() > "14-02-2026" ? (
          <CountdownTimer targetDate="2026-02-14" />
        ) : (
          <div className="restart-section">
            <p className="restart-text">Want to experience the magic again?</p>
            <button id="btn-restart" className="btn btn-restart-final">
              <span className="btn-icon">💝</span>
              <span className="btn-text" onClick={() => navigate("/")}>
                Start Over
              </span>
              <div className="btn-hearts">
                <span>💕</span>
                <span>💖</span>
                <span>💗</span>
              </div>
            </button>
          </div>
        )}

        {/* Computer Decoration */}
        <div className="computer-decoration">
          <svg viewBox="0 0 80 80">
            <rect
              x="10"
              y="10"
              width="60"
              height="45"
              rx="3"
              fill="#FF1493"
              stroke="#C71585"
              strokeWidth="2"
            />
            <rect x="15" y="15" width="50" height="35" fill="#FFB6C1" />
            <text x="35" y="38" fontSize="15">
              ❤️
            </text>
            <rect x="30" y="55" width="20" height="15" fill="#8B4513" />
            <rect x="20" y="70" width="40" height="5" fill="#8B4513" />
            <rect
              x="5"
              y="65"
              width="15"
              height="12"
              fill="#FF1493"
              stroke="#C71585"
              strokeWidth="1"
            />
            <text x="8" y="74" fontSize="8">
              💕
            </text>
          </svg>
        </div>
      </div>
    </section>
  );
};

export default SurpriseScreen;
